export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
export const APPLY_PROMO_CODE = 'APPLY_PROMO_CODE';
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE';
export const SET_USER = 'SET_USER';
export const CLEAR_CART = 'CLEAR_CART';
export const SET_CART_ITEMS_FROM_STORAGE = 'SET_CART_ITEMS_FROM_STORAGE';
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const RESET_BILL = 'RESET_BILL';
export const SET_BILL_TYPE = 'SET_BILL_TYPE';
export const SET_CUSTOMER_TYPE = 'SET_CUSTOMER_TYPE';
export const SET_TRANSPORT_ENABLED = 'SET_TRANSPORT_ENABLED';
export const SET_TRANSPORT_DETAILS = 'SET_TRANSPORT_DETAILS';
export const SET_BILL_ROWS = 'SET_BILL_ROWS';
